import uuid from '@skillbox/request-id';
import { showAlchemerePopup } from '../components/Alchemere';
import activeCloudPayments from '../libs/cloudpayments';

const priceData = document.querySelector('#price')?.dataset.lerna;

window.$lerna = {
  priceData: priceData ? JSON.parse(priceData) : null,
  getFormData: () => window.cFormAutocomplete?.getFields(),
  saveData: (type, data) => window.cFormAutocomplete?.saveData({ type, data }),
  getRequestId: () => uuid.generateRequestId('L'),
  showPopup: () => showAlchemerePopup('order'),
  activeCloudPayments: (data) => {
    window.$paymentData = data;
    activeCloudPayments();
  }
}
